/* eslint-disable */
import {
  GET_DEPARTMENT_STATISTICS_FAIL,
  GET_DEPARTMENT_STATISTICS_START,
  GET_DEPARTMENT_STATISTICS_SUCCESS,
  GET_DEPARTMENTS_FAIL,
  GET_DEPARTMENTS_START,
  GET_DEPARTMENTS_SUCCESS,
} from './constants';

import { API_URL } from '@shared/constants/config';
import { GET, REST_API } from '@shared/constants/rest-api';

const headers = {
  Accept: '*/*',
  'Content-Type': 'application/json',
};

const defaultToken = '';

export const getDepartments = (params, onSuccess) => ({
  type: REST_API,
  method: GET,
  url: `${API_URL}/department`,
  params: {
    sort: 'name,asc',
    ...params,
  },
  headers: {
    ...headers,
    Authorization: localStorage.getItem('authorizationToken') || defaultToken,
  },
  types: [GET_DEPARTMENTS_START, GET_DEPARTMENTS_SUCCESS, GET_DEPARTMENTS_FAIL],
  onSuccess,
});

export const getDepartmentStatistics = (params, onSuccess) => ({
  type: REST_API,
  method: GET,
  url: `${API_URL}/department/statistics`,
  params: {
    sort: 'name,asc',
    ...params,
  },
  headers: {
    ...headers,
    Authorization: localStorage.getItem('authorizationToken') || defaultToken,
  },
  types: [GET_DEPARTMENT_STATISTICS_START, GET_DEPARTMENT_STATISTICS_SUCCESS, GET_DEPARTMENT_STATISTICS_FAIL],
  onSuccess,
});
